import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './App.css';

class Tile extends Component {
  filling = {
    color: "#fff"
  }

  borderColor = {
    border: "3px solid " + this.props.borderColor
  }

  handleClick() {
    alert('hello');
  }

  render() {
    //console.log(this.props);
    return (
      <div className="tile-container" style={this.borderColor}>
        <div className="tile-filling">
          <div className="tile-text" style={this.filling}>
           <Link to={this.props.url}> {this.props.text} </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default Tile;



/** WEBPACK FOOTER **
 ** ./src/Tile.js
 **/